import React, { useState } from 'react';
import { Table, Collapse } from 'antd';
import _ from 'lodash';
import './CardPoiGet.scss';
import { BaseCard } from '../BaseCard';
import DynamicIcon from '@bvt-icons';
import { Svg } from '@bvt-atoms';
import * as BvtIcon from 'bvt-icon';
import { JSONcombine } from '@bvt-features/genset/poi/redux/GENSET_CONSUME_POI_ACTION';
import { getIcon } from '@bvt-shared/utils/iconUtils';

/**
 * @author Randa<m.randa@bvarta.com>
 * @copyright PT Bhumi Varta Technology
 * @type {React.FC<{
 * data:Array<{industryCode:string,name:string,color:string,groups:Array<{brandName:string,groupName:string,categoryName:string,subTotal:number}>}>
 * isLoading:boolean
 * extraLabel?:string | React.ReactNode
 * title?:string
 * }>}
 */
const CardPoiGet = (props) => {
  const { data, isLoading, extraLabel, style, title = 'Poi Get' } = props;

  const [activePanels, setActivePanels] = useState([]);

  const renderIcon = ({ isActive }) => (
    <DynamicIcon className={`${isActive ? 'active' : ''}`} icon='arrowfilled' />
  );

  const handleCollapseChange = (key) => {
    setActivePanels(key);
  };

  return (
    <div className='shared CardPoiGet' style={style}>
      <BaseCard
        className='poi'
        isLoading={isLoading}
        title={title}
        withPadding={true}
      >
        <div>{extraLabel}</div>
        <div className='Wrapper__POI'>
          {data?.map((vData) => {
            return (
              <Collapse
                activeKey={activePanels}
                className=''
                expandIcon={renderIcon}
                key={vData.industryCode}
                onChange={handleCollapseChange}
              >
                <Collapse.Panel
                  header={
                    <div className='CardPoiGet__category-wrap'>
                      <div className='CardPoiGet__category-wnh'>
                        {vData?.name}
                      </div>
                      <div className='CardPoiGet__category-wnh'>
                        {_.sumBy(vData.groups, (value) => value.subTotal)} POI
                      </div>
                    </div>
                  }
                  key={vData.industryCode}
                  style={{
                    background: !`${vData?.color}`?.includes('#')
                      ? JSONcombine.find(
                        (item) => item.code === vData.industryCode
                      )?.color
                      : vData.color,
                  }}
                >
                  <Table
                    className='CardPoiGet__table'
                    columns={[
                      {
                        dataIndex: 'icon',
                        key: 'icon',
                        title: 'Icon',
                        width: 52,
                        align: 'center',
                        render: (vIcon) => {
                          const link = getIcon('poi', vIcon);
                          return vIcon ? (
                            <Svg src={link} type='link' />
                          ) : (
                            <BvtIcon.DefaultPoi height='22' width='22' />
                          );
                        },
                      },
                      {
                        title: 'Group',
                        dataIndex: 'groupName',
                      },
                      {
                        title: 'Category',
                        dataIndex: 'categoryName',
                      },
                      {
                        title: 'Brand',
                        dataIndex: 'brandName',
                      },
                      {
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        title: 'Sub Total',
                        sorter: (a, b) => a.subTotal - b.subTotal,
                        width: 128,
                        align: 'center',
                        showSorterTooltip: false,
                        onCell: () => ({ style: { color: '#07827C' } }),
                      },
                    ]}
                    dataSource={vData.groups || []}
                    pagination={false}
                  />
                </Collapse.Panel>
              </Collapse>
            );
          })}
        </div>
        <div
          className='CardPoiGet__category-wrap'
          style={{ background: '#8B9DB2' }}
        >
          <div className='CardPoiGet__category-wnh' style={{ margin: 'auto' }}>
            {_.sumBy(data, (v) => _.sumBy(v.groups, (value) => value.subTotal))}{' '}
            Total
          </div>
        </div>
      </BaseCard>
    </div>
  );
};

CardPoiGet.displayName = 'CardPoiGet';

export { CardPoiGet };
